module.exports = __webpack_public_path__ + "img/mini-020.bf1fb06d.jpg";